module.exports = __webpack_public_path__ + "static/media/rumour.fdedfa62.svg";